import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, Transition as _Transition, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/images/logo-small.png';
import _imports_1 from '@/assets/images/logo.png';
import _imports_2 from '@/assets/images/logo-dark.png';
var _hoisted_1 = {
  key: 0,
  src: _imports_0
};
var _hoisted_2 = {
  key: 1,
  src: _imports_1
};
var _hoisted_3 = {
  key: 2,
  src: _imports_2
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_i_link = _resolveComponent("i-link");
  var _component_i_menu_side_item = _resolveComponent("i-menu-side-item");
  var _component_i_menu_side_submenu = _resolveComponent("i-menu-side-submenu");
  var _component_Tooltip = _resolveComponent("Tooltip");
  var _component_i_menu_side_collapse = _resolveComponent("i-menu-side-collapse");
  var _component_Menu = _resolveComponent("Menu");
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", {
    class: _normalizeClass(["i-layout-sider-logo", {
      'i-layout-sider-logo-dark': _ctx.siderTheme === 'dark'
    }])
  }, [_createVNode(_Transition, {
    name: "fade-quick",
    persisted: ""
  }, {
    default: _withCtx(function () {
      return [_withDirectives(_createVNode(_component_i_link, {
        to: "/"
      }, {
        default: _withCtx(function () {
          return [_ctx.menuCollapse ? (_openBlock(), _createElementBlock("img", _hoisted_1)) : _ctx.siderTheme === 'light' ? (_openBlock(), _createElementBlock("img", _hoisted_2)) : (_openBlock(), _createElementBlock("img", _hoisted_3))];
        }),
        _: 1 /* STABLE */
      }, 512 /* NEED_PATCH */), [[_vShow, !$props.hideLogo]])];
    }),
    _: 1 /* STABLE */
  })], 2 /* CLASS */), _createVNode(_component_Menu, {
    ref: "menu",
    class: _normalizeClass(["i-layout-menu-side i-scrollbar-hide", {
      'i-layout-menu-side-collapse': _ctx.menuCollapse
    }]),
    theme: _ctx.siderTheme,
    accordion: _ctx.menuAccordion,
    "active-name": _ctx.activePath,
    "open-names": _ctx.openNames,
    width: "auto"
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterSider, function (item, index) {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: index
        }, [!_ctx.menuCollapse ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [item.children === undefined || !item.children.length ? (_openBlock(), _createBlock(_component_i_menu_side_item, {
          key: 0,
          menu: item
        }, null, 8 /* PROPS */, ["menu"])) : (_openBlock(), _createBlock(_component_i_menu_side_submenu, {
          key: 1,
          menu: item
        }, null, 8 /* PROPS */, ["menu"]))], 64 /* STABLE_FRAGMENT */)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [item.children === undefined || !item.children.length ? (_openBlock(), _createBlock(_component_Tooltip, {
          content: _ctx.tTitle(item.title),
          placement: "right",
          key: index,
          theme: _ctx.siderTheme
        }, {
          default: _withCtx(function () {
            return [_createVNode(_component_i_menu_side_item, {
              class: "i-layout-menu-side-collapse-top-item",
              menu: item,
              "hide-title": ""
            }, null, 8 /* PROPS */, ["menu"])];
          }),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["content", "theme"])) : (_openBlock(), _createBlock(_component_i_menu_side_collapse, {
          key: 1,
          menu: item,
          "top-level": ""
        }, null, 8 /* PROPS */, ["menu"]))], 64 /* STABLE_FRAGMENT */))], 64 /* STABLE_FRAGMENT */);
      }), 128 /* KEYED_FRAGMENT */))];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class", "theme", "accordion", "active-name", "open-names"])]);
}